import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const CLOSE = 'close_modal++'
export const TITLE = 'title_modal++'
export const LABEL = 'LABEL_modal++'

export default {
  [PORTUGUESE]: {
    [CLOSE]: 'Fechar',
    [TITLE]: 'Opções de Alternativa',
    [LABEL]: 'Texto atual',
  },

  [ENGLISH]: {
    [CLOSE]: 'Close',
    [TITLE]: 'Alternative Options',
    [LABEL]: 'Current Label',
  },

  [SPANISH]: {
    [CLOSE]: 'Fechar',
    [TITLE]: 'Opciones de Alternativa',
    [LABEL]: 'Texto atual',
  },
}
